export const OPM = `OPM`;

export const GET_AGENT_INFO_BY_CODE = `${OPM}/GET_AGENT_INFO_BY_CODE`;
export const SET_AGENT_INFO_BY_CODE = `${OPM}/SET_AGENT_INFO_BY_CODE`;

export const GET_OPM_ASSIGNMENT_LIST = `${OPM}/GET_OPM_ASSIGNMENT_LIST`;
export const SET_OPM_ASSIGNMENT_LIST = `${OPM}/SET_OPM_ASSIGNMENT_LIST`;

export const GET_AGENTS_UNDER_AD = `${OPM}/GET_AGENTS_UNDER_AD`;
export const SET_AGENTS_UNDER_AD = `${OPM}/SET_AGENTS_UNDER_AD`;

export const GET_ELIGIBLE_POLICIES = `${OPM}/GET_ELIGIBLE_POLICIES`;
export const SET_ELIGIBLE_POLICIES = `${OPM}/SET_ELIGIBLE_POLICIES`;

export const GET_SUITABLE_AGENTS = `${OPM}/GET_SUITABLE_AGENTS`;
export const SET_SUITABLE_AGENTS = `${OPM}/SET_SUITABLE_AGENTS`;

export const APPROVE_OPM_ASSIGNMENT = `${OPM}/APPROVE_OPM_ASSIGNMENT`;
export const REJECT_OPM_ASSIGNMENT = `${OPM}/REJECT_OPM_ASSIGNMENT`;
